var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4 18V2.4H16.8V18C16.8 18.4208 16.8722 18.8247 17.0048 19.2H3.6C2.93726 19.2 2.4 18.6627 2.4 18ZM20.4 21.6H3.6C1.61177 21.6 0 19.9882 0 18V0H16.8H18H19.2L19.2 6H24L24 7.2L24 8.4L24 18C24 19.9882 22.3882 21.6 20.4 21.6ZM19.2 8.4H21.6V18C21.6 18.6627 21.0627 19.2 20.4 19.2C19.7373 19.2 19.2 18.6627 19.2 18L19.2 8.4ZM9.6 4.8V9.6H4.8V4.8H9.6ZM14.4 8.4V6H10.8V8.4H14.4ZM14.4 10.8V13.2H4.8V10.8H14.4ZM14.4 16.8V14.4H4.8V16.8H14.4Z",
    fill: "#a1c9b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.59904b8d116d8e25fbe0c66fbe115774.svg";
export { ForwardRef as ReactComponent };